
export enum InputState {
    Low = 0,
    High = 1
}

export enum HardwareSource {
    Tracker = 0,
    Transcan = 1,
    SecureSeal = 2,
    Ibox = 3,
    Carrier = 4
}

export enum InputStateDescription {
    OnOff,
    OpenClosed,
    ActiveInactive,
    ConnectedDisconnected,
}

export interface IVehicleInput {
    Id: number,
    Position: number,
    
    VehicleId: number,
    Source: HardwareSource;
    ActiveState: InputState;
    InputStateDescription: InputStateDescription;
    InputTypeId?: number;

    ZoneId?: number;

    // ---

    inputSourceString: string;
    name: string,
}
